import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Button from '../../components/atoms/Buttons/CommonBtn';
import Link from '../../components/atoms/Link';
import LoadingSpinner from '../../components/atoms/LoadingSpinner';
import LogoTopiiTigo from '../../components/atoms/LogoTopiiTigo';
import Switch from '../../components/atoms/Switch';
import Text from '../../components/atoms/Text';
import {useTranslation} from '../../context/language';
import {theme} from '../../styles/darkTheme'; //Temporal
import {
  Container,
  ContentContainer,
  TopContainer,
  BottomContainer,
  SwitchContainer,
} from './styles';
import {useQuery} from '../../hooks/useQuery';
import axios from '../../utils/axios';
import {parsePhoneNumber} from 'libphonenumber-js';
import {useDispatch, useSelector} from 'react-redux';
import {SET_USER} from '../../redux/actionTypes';
import {UserState} from '../../redux/reducers/user';
import {chatClient} from '../../config/get-stream';
import {
  setAlert,
  setPrivacyModalVisible,
  setTermsModalVisible,
} from '../../redux/actions/global';
import {getErrorMessage} from '../../utils/getters';
import env from 'react-dotenv'
import {TOPII_POLICY, TOPII_TERMS} from '../../utils/constants';
import PrivacyModal from '../../components/molecules/PrivacyModal';
import TermsModal from '../../components/molecules/TermsModal';
import {RootState} from '../../redux/reducers';
import {setChannelSearch, setChannelSearchSuccess} from '../../redux/actions/channel';
import {ChannelService} from '../../services/Channel';

const OnBoarding: React.FC<Record<string, unknown>> = () => {
  const {title, text} = useTranslation();
  const [accept, setAccept] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [doc, setDoc] = useState('');
  const [visible, setVisible] = useState(false);
  const [visibleT, setVisibleT] = useState(false);
  const [loading, setLoading] = useState(false);
  const [nextPage, setNextPage] = useState('/welcome');
  const history = useNavigate();
  const query = useQuery();
  const dispatch = useDispatch();
  const {channelSearch = []} = useSelector((state: RootState) => ({
    ...state.channel,
  }));

  const FONT_SIZE_14 = '14px';
  const FONT_SIZE_24 = '24px';
  const LINE_HEIGHT_20 = '20px';
  const LINE_HEIGHT_32 = '24px';
  const FONT_WEIGHT_BOLD = 'bold';

  const handleClick = (): void => {
    if (accept) history(nextPage);
  };

  const getTerms = async () => {
    try {
      const res = await axios.get(TOPII_TERMS)
      setDoc(res.data)
      setVisibleT(true)
    } catch (e) {
      console.log(e)
    }
  }

  const getPolicy = async () => {
    try {
      const res = await axios.get(TOPII_POLICY)
      setDoc(res.data)
      setVisible(true)
    } catch (e) {
      console.log(e)
    }
  }

  const getUserData = () => {
    const queryNum = query.get('number');
    if (!queryNum) return null;
    const data = {
      encryptedNumber: queryNum.replaceAll(' ', '+'),
    };
    return data;
  };


  const loginUser = async (data: any) => {
    const url = 'api/v1/auth/widget/login/';
    const res = await axios.post(url, data, );
    return res.data;
  };

  const saveUser = async (data: any) => {
    const {
      firebase_uid,
      id,
      phoneNumber,
      dialCountryCode,
      streamToken,
      profile,
    } = data;
    await chatClient.connectUser(
      {
        id,
        ...profile,
      },
      streamToken,
    );
    const currentUser: UserState = {
      id,
      dialCountryCode: dialCountryCode,
      mobileNumber: phoneNumber,
      streamToken: streamToken,
      profile,
    };
    dispatch({type: SET_USER, payload: currentUser});
  };

  useEffect(() => {
    const validateUser = async () => {
      const userData = getUserData();
      if (!userData) return;
      const url = 'api/v1/user/widget/validate/';
      try {
        setLoading(true);
        const validResp = await axios.post(url, userData,);
        const loginResp = await loginUser(userData);
        await saveUser(loginResp);
        setLoading(false);
        if (!loginResp.profile) {
          return setNextPage('/register');
        }
        if (validResp.data.valid) {
          if (validResp.data.haveRemittances) {
            return history('/chats');
          } else {
            ChannelService.getChannels({members: [loginResp.id]})
                .then(channels => {
                  if (channels.length > 0){
                    return history('/chats')
                  } else {
                    return history('/welcome');
                  }
                })
                .catch(err => {
                  //Add alert
                  console.log(err);
                })
          }

        }
      } catch (e: any) {
        setLoading(false);
        setDisabled(true);
        dispatch(
          setAlert({
            title: e.name,
            message: getErrorMessage(400, text),
          }),
        );
      }
    };
    validateUser();
  }, []);

  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <Container theme={theme}>
          <PrivacyModal content={doc} visible={visible} setVisible={setVisible} />
          <TermsModal content={doc} visible={visibleT} setVisible={setVisibleT} />
          <ContentContainer>
            <TopContainer>
              <LogoTopiiTigo />
            </TopContainer>
            <BottomContainer>
              <Text
                fontColor={theme.lightText}
                fontSize={'16px'}
                fontWeight={FONT_WEIGHT_BOLD}
                textAlign={'justify'}
                lineHeight={LINE_HEIGHT_32}>
                {title.onBoarding}
              </Text>
              <SwitchContainer>
                <Switch theme={theme} enabled={accept} setEnabled={setAccept} />
                <Text
                  fontColor={theme.lightText}
                  fontSize={FONT_SIZE_14}
                  lineHeight={LINE_HEIGHT_20}>
                  {text.readTerms}
                  <Link
                    onClick={() =>
                      getTerms()
                    }
                    fontColor={theme.lightText}
                    fontSize={FONT_SIZE_14}
                    fontWeight={FONT_WEIGHT_BOLD}
                    lineHeight={LINE_HEIGHT_20}>
                    {text.termsOfUse}
                  </Link>
                  {text.termsAnd}
                  <Link
                    onClick={() =>
                      getPolicy()
                    }
                    fontColor={theme.lightText}
                    fontSize={FONT_SIZE_14}
                    fontWeight={FONT_WEIGHT_BOLD}
                    lineHeight={LINE_HEIGHT_20}>
                    {text.privacyPolicy}
                  </Link>
                  {text.ofTigo}
                </Text>
              </SwitchContainer>
              <Button onClick={handleClick} validation={accept}>
                {text.onBoardingButton}
              </Button>
            </BottomContainer>
          </ContentContainer>
        </Container>
      )}
    </>
  );
};

export default OnBoarding;
